import React from "react";
import { Database, LineChart, BarChart3, Bot } from "lucide-react";
import { Reveal, Eyebrow, StaggerGroup, StaggerItem } from "./Reveal";
import { COURSE } from "../../data/course";

const ICONS = [Database, LineChart, BarChart3, Bot];

export default function Learn() {
  return (
    <section id="learn" data-testid="learn-section" className="relative py-24 md:py-32">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal>
          <Eyebrow>What You&apos;ll Learn</Eyebrow>
        </Reveal>
        <div className="mt-6 flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <Reveal delay={0.1}>
            <h2 className="max-w-2xl font-display text-4xl font-semibold leading-[1.05] tracking-tight text-[#293891] sm:text-5xl">
              From raw data to real decisions.
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="max-w-sm text-base leading-relaxed text-[#566076]">
              A complete analyst skillset — the technical craft and the AI leverage that sets you apart.
            </p>
          </Reveal>
        </div>

        <StaggerGroup className="mt-14 grid gap-5 md:grid-cols-3">
          {COURSE.learn.map((item, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <StaggerItem
                key={item.title}
                className={`card-glow relative overflow-hidden rounded-3xl border border-[#293891]/10 bg-[#FFFFFF] p-8 ${item.span}`}
              >
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 glow-blue opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-[#293891]/10 bg-[#293891]/[0.03] text-[#3B82F6]">
                  <Icon size={22} />
                </div>
                <h3 className="mt-6 font-display text-2xl font-medium text-[#293891]">{item.title}</h3>
                <p className="mt-3 max-w-md text-sm leading-relaxed text-[#566076]">{item.desc}</p>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
}
